module.exports = __webpack_public_path__ + "static/group3_3-0dff2cfcd4c8363891f465d959d8e5e7.webp";